
$(document).ready(function () {

  // Modify view to show available options
  const managePaymentOptionsWizoSubscription = () => {
    // Show/hide available options
    const selector = ".payment-selection .custom-control";
    $(`${selector}`).addClass("hidden-input");
    $(`${selector}.payment-clp.payment-once`).removeClass(
      "hidden-input"
    );
  };
  // Donation type selector
  $(".donation-type-select button").click(({ target }) => {
    var type = target.getAttribute("data-type");
    $("#recurring-radio-container").addClass("d-flex").removeClass("d-none");
    $(".invalid-amount").removeClass("d-none");
    if (type === "wizo-subscription") {
      managePaymentOptionsWizoSubscription();
      $("#amount_form.dynamic-label label").text('Ingresa el monto de tu cuota social');
      $(".wizo-subscription").show();
      $(".wizo-subscription").prop('required', true);
      $(".single-donation").hide();
      $("#donator_email_label").html("Ingresa tu email");
      $("#donator_email_fundraising").prop('required', true);
      $("#recurring-checkbox").prop("checked", false);
      $("#recurring-radio-container").hide();
      $(".app-container").show();
      $(".card-container").hide();
      $(".greeting-cards-banner").hide();
      $(".charity-wreaths-container").hide();
      $("#subscription-wizo-header").show();
      $("#subscription-header").hide();
      $("#once-header").hide();
      $("#subscription-wizo-label").show();
      $("#donator_donation_transactions_attributes_0_location_id").val(3243);
      $("#donator_donation_transactions_attributes_0_description").val('cuota social');
      $(".image-container.platform")[0].style.backgroundImage = "url('https://storage.googleapis.com/fundingplatform-files/staging/wizo/socias-wizo-2.png')"
      $(".currency-selection label[data-currency='usd']").hide();
      $("#recurring-radio-container").removeClass("d-flex").addClass("d-none");
      $(".invalid-amount").addClass("d-none");
    } else if (type === "once") {
      $(".wizo-subscription").hide();
      $(".wizo-subscription").prop('required', false);;
      $(".single-donation").show();
      $("#donator_email_label").html("Ingresa tu email");
      $("#donator_email_fundraising").prop('required', true);
      $("#subscription-wizo-header").hide();
      $("#recurring-radio-container").show();
      $("#subscription-wizo-label").hide();
      $("#donator_donation_transactions_attributes_0_description").val('');
      $(".image-container.platform")[0].style.backgroundImage = "url('https://storage.googleapis.com/fundingplatform-files/staging/wizo/wizo-once.png')"
    } else if (type === "subscription") {
      $(".wizo-subscription").hide();
      $(".wizo-subscription").prop('required', false);;
      $(".single-donation").show();
      $(".single-donation").show();
      $("#donator_email_label").html("Ingresa tu email");
      $("#subscription-wizo-header").hide();
      $("#recurring-radio-container").show();
      $("#subscription-wizo-label").hide();
      $("#donator_donation_transactions_attributes_0_description").val('');
      $(".image-container.platform")[0].style.backgroundImage = "url('https://storage.googleapis.com/fundingplatform-files/staging/wizo/wizo-once.png')"
    }
  });

  // Wizo subscription validation
  $("#wizo-amount").change((event) => {
    $("#donator_donation_transactions_attributes_0_amount").val($("#wizo-amount").val())
  });
});
